// extracted by mini-css-extract-plugin
module.exports = {"dialogContact":"DialogBlock_dialogContact_2dx9K"};